import dayjs, { Dayjs } from "utils/dayjs"
import { Guid } from "@/types"
import RequestLocation from "./RequestLocation"

export interface IGetShippingOrderSegment {
    id: Guid
    departureLocationId: Guid
    departureDate: string
    arrivalLocationId: Guid
    arrivalDate: string
    note?: string | null
    confirmationComment?: string | null
    completeDate?: string | null
    completeComment?: string | null
    completionReportUri?: string | null
}

interface IShippingOrderSegmentParams {
    departureLocation?: RequestLocation
    arrivalLocation?: RequestLocation
}

export default class ShippingOrderSegment {
    id: Guid
    departureDate: Dayjs
    arrivalDate: Dayjs
    note?: string
    confirmationComment?: string
    completeDate?: Dayjs
    completeComment?: string
    completionReportUri?: string
    departureLocationId: Guid
    departureLocation?: RequestLocation
    arrivalLocationId: Guid
    arrivalLocation?: RequestLocation

    constructor(dto: IGetShippingOrderSegment, { departureLocation, arrivalLocation }: IShippingOrderSegmentParams) {
        this.id = dto.id
        this.departureDate = dayjs.utc(dto.departureDate)
        this.arrivalDate = dayjs.utc(dto.arrivalDate)
        this.note = dto.note || undefined
        this.confirmationComment = dto.confirmationComment || undefined
        this.completeDate = dto.completeDate ? dayjs.utc(dto.completeDate) : undefined
        this.completeComment = dto.completeComment || undefined
        this.completionReportUri = dto.completionReportUri || undefined
        this.departureLocationId = dto.departureLocationId
        this.departureLocation = departureLocation
        this.arrivalLocationId = dto.arrivalLocationId
        this.arrivalLocation = arrivalLocation
    }

    get isCompleted(): boolean {
        return !!this.completeDate
    }
}
